import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
	error?: Error;
}

/**
 * Error Boundary component to catch and handle React component errors
 * @class ErrorBoundary
 */
class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
	};

	public static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("Uncaught error:", error, errorInfo);
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div className='error-boundary'>
					<h2>Something went wrong.</h2>
					<details>
						<summary>Error Details</summary>
						<pre>{this.state.error?.toString()}</pre>
					</details>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
